import * as React from 'react'
import { DisplayContent, Plural, Singular } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import { FunnelOrder } from '../../data/models/funnelOrder'
import { getRoomType, roomType } from '../../data/models/funnelOrder/roomType'
import { getDriveDestination } from '../../data/models/funnelOrder/summary'
import { AppState } from '../../data/state'
import CO2Summary from './shared/CO2Summary'
import DepartureDateSummary from './shared/DepartureDate'
import ExcludedCitiesSummary from './shared/ExcludedCitiesSummary'
import NoteSummary from './shared/NoteSummary'
import NrPeopleSummary from './shared/NrPeopleSummary'

interface MultiDriveSummaryProps {
  funnelOrder: FunnelOrder
  loading: boolean
}

const MultiDriveSummary: React.FC<MultiDriveSummaryProps> = ({
  funnelOrder,
  loading,
}) => {
  const loadingClass = loading ? 'is-loading' : ''
  return (
    <>
      <NrPeopleSummary />
      <DepartureDateSummary />
      <ListItem>
        <span className={loadingClass}>
          <DisplayContent
            contentKey="days-summary"
            vars={{ days: funnelOrder.days.toString() }}
            plural={funnelOrder.days > 1}
          >
            <Singular>{`${funnelOrder.days} day`}</Singular>
            <Plural>{`${funnelOrder.days} days`}</Plural>
          </DisplayContent>
          ,&nbsp;
          <DisplayContent
            contentKey="destination-summary"
            vars={{ locations: funnelOrder.locations.toString() }}
            plural={funnelOrder.locations > 1}
          >
            <Singular>{`${funnelOrder.locations} destination`}</Singular>
            <Plural>{`${funnelOrder.locations} destinations`}</Plural>
          </DisplayContent>
        </span>
      </ListItem>
      <ExcludedCitiesSummary />
      <ListItem>{getDriveDestination(funnelOrder.driveDestination)}</ListItem>
      <ListItem>
        <span className={loadingClass}>
          {getRoomType(funnelOrder.roomType)}&nbsp;
          {funnelOrder.roomType === roomType.premium ? (
            <DisplayContent contentKey="premium-accomodation-summary">
              hotel
            </DisplayContent>
          ) : (
            <DisplayContent contentKey="accomodation-summary">
              accomodation
            </DisplayContent>
          )}
        </span>
      </ListItem>
      <NoteSummary />
      <CO2Summary />
    </>
  )
}

export default connect((state: AppState) => ({
  funnelOrder: state.funnelOrder,
  loading: state.contentEngine.loading,
}))(MultiDriveSummary)
